var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"left"},[_vm._t("left",function(){return [(_vm.showBack)?_c('i',{staticClass:"iconfont icon-fanhui",on:{"click":_vm.goBack}}):_vm._e()]})],2),_c('div',{staticClass:"center"},[_vm._t("default")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }